import debounce from 'lodash/debounce';
import handleLoad from './handleLoad';
import handleReset from './handleReset';
import fillDropdown from './fillDropdown';
import switchHeader from './switchHeader';
import handleFilterReset from './handleFilterReset';
import handleSummaryUpdate from '../filter/handleSummaryUpdate';
import handleEventMap from '../common/handleEventMap';
import getSelectionData from '../common/getSelectionData';
import handleItemRemove from './handleItemRemove';

/**
 * Attach interactions to every element that matches selector.
 */
$('.references').each((_, component) => {
    // detach and cache item template
    const $itemTemplate = $(component).find('.references__item[data-template]')
        .removeAttr('data-template')
        .detach();

    // detach and cache summary item template
    const $summaryItemTemplate = $(component).find('.filter__summary__item[data-template]')
        .removeAttr('data-template')
        .detach();

    $(component)
        .on('change', '.references__filter input', handleReset(component, $itemTemplate))
        .on('select:change', debounce(handleSummaryUpdate(component, $summaryItemTemplate, true)))
        .on('select:change', debounce(handleEventMap(component, 'filter:change', getSelectionData)))
        .on('click', '.filter__summary__item', handleItemRemove(component, $itemTemplate))
        .on('click', '.filter__summary__reset', handleFilterReset(component, $itemTemplate))
        .on('click', '.loader', handleLoad(component, $itemTemplate));

    $('.select__item__input').on('change', switchHeader);
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                handleLoad(component, $itemTemplate);
                observer.unobserve(entry.target);
            }
        });
    }, { rootMargin: '-100px' });
    const refElems = document.querySelectorAll('.reference-box', '.references');
    refElems.forEach(element => {
        observer.observe(element);
    });
    $(window).on('load', fillDropdown(new URL(window.location)));
});



// WEBPACK FOOTER //
// ./src/scripts/components/references/index.js